import { Image } from "capitalrx-components-2.0";

import advantageCard from "@/static/images/advantage-card-min.jpg";
import pharmacist from "@/static/images/image-pharmacist-min.jpg";
import pillBottle from "@/static/images/image-pill-bottles-min.jpg";
import manChild from "@/static/images/image-man-and-child-min.jpg";

import { FAQDataProps } from "./FAQSection.props";

export const faqData: Array<FAQDataProps> = [
  {
    title: "Am I eligible to use this card?",
    content:
      "Everyone is eligible to use the Capital Rx Advantage Card. While this is not a health insurance program, presenting this prescription savings card to the pharmacist can help you and your family get discounts on your prescriptions.",
    Image: <Image src={advantageCard} alt="Advantage Card" ariaHidden="true" />,
    id: "eligible-to-use-card",
  },
  {
    title: "Do I need to pay for this card?",
    content: "No. We believe in affordable and ethical healthcare. The Capital Rx Advantage prescription savings card is free to download.",
    Image: <Image src={manChild} alt="Man sitting with child" ariaHidden="true" />,
    id: "pay-for-card",
  },
  {
    title: "How do I use this card?",
    content:
      "Simply present the card to your pharmacist when you fill your prescriptions to find discounts on your prescriptions. This card is not a health insurance program and cannot be combined with any other third-party insurance, including Medicare and Medicaid.",
    Image: <Image src={pharmacist} alt="Pharmacist" ariaHidden="true" />,
    id: "use-card",
  },
  {
    title: "Which medications are covered?",
    content:
      "The Capital Rx Advantage card helps you to save on most of the prescriptions that you and your family depend on to live healthy lives.",
    Image: <Image src={pillBottle} alt="Pill Bottles" ariaHidden="true" />,
    id: "medication-covered",
  },
  {
    title: "What pharmacies accept this card?",
    content: "To find a pharmacy that accepts the Capital Rx Advantage card, look up your medication in the Find Best Price tool. Ask your pharmacy to run the card and check the price, even if they tell you they have another card they use.",
    id: "what-pharmacy",
  },
  {
    title: "Will the price shown on the website be the price I get at the pharmacy?",
    content: "Most likely yes. The price could differ if you searched for a different quantity or strength than your prescription. In addition, our price based upon an estimate of which NDC (national drug code) is most common for the selected strength and form of the drug. If your pharmacy has a different NDC drug in stock, the price may differ as there could be multiple prices for the same drug if they have different manufacturers.",
    id: "price-match",
  },
];
